// extracted by mini-css-extract-plugin
export var categoryList = "desktop-nav-module--categoryList--2f45d";
export var categoryListItem = "desktop-nav-module--categoryListItem--5129d";
export var desktopNav = "desktop-nav-module--desktopNav--58558";
export var hover = "desktop-nav-module--hover--407e0";
export var list = "desktop-nav-module--list--95c0a";
export var listItem = "desktop-nav-module--listItem--e5f90";
export var listItemHover = "desktop-nav-module--listItemHover--0831b";
export var megaMenu = "desktop-nav-module--megaMenu--4e19d";